import { deleteSubscription, getSubscription } from "@/services/subscription/subscription.service"
import { useRequest } from "ahooks"
import { Button, Popconfirm, Space, Table, Tooltip } from "antd"
import { SubscriptionModal } from "./SubscriptionModal"

export const SubscriptionList = () => {
  const {data, run: getSubscritionList} = useRequest(() => getSubscription())

  const handledDeleteSubscription = async (record) => {
    if (!record) return
    await deleteSubscription(record.id)
    getSubscritionList()
  }

  const columns = [
    {
      title: 'User',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Plan Name',
      dataIndex: 'plan',
      key: 'plan',
    },
    {
      title: 'Billing Frequency',
      dataIndex: 'billingFrequency',
      key: 'billingFrequency',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Currency',
      dataIndex: 'currency',
      key: 'currency',
    },
    {
      title: 'Subscription End',
      dataIndex: 'subscriptionEnd',
      key: 'subscriptionEnd',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Stripe',
      dataIndex: 'stripeId',
      key: 'stripeId',
      render: (stripeId: string) => {
        if (stripeId) {
          return <Tooltip title={stripeId}>
            <span>{stripeId.substring(0, 4)}...</span>
          </Tooltip>
        }
        return stripeId
      }
    },
    {
      title: 'Actions',
      render: (curRecord) => {
        return <Space>
          <Button type='link' size='small'
            onClick={() => {
              SubscriptionModal.show({
                subscription: curRecord,
                onSuccess: async () => {
                  getSubscritionList()
                }
              })
            }}
          
          >Edit</Button>
          <Popconfirm
            title="Delete the Subscription"
            description="Are you sure to delete this Subscription?"
            onConfirm={() => handledDeleteSubscription(curRecord)}
            okText="Yes"
            cancelText="No"
          >
            <Button type='link' danger size='small'>Delete</Button>
          </Popconfirm>
          
        </Space>
      }
    }
  ]

  return <div>
    <div className="flex-end mb-2">
      <Button
        type="primary"
        onClick={() => {
          SubscriptionModal.show({
            onSuccess: async () => {
              getSubscritionList()
            }
          })
        }}
      >Add Subscription</Button>
    </div>
    <Table columns={columns} dataSource={data} size="small" bordered/>
  </div>
}